<template>
  <div class="common-poup bind-tel-box">
    <h1 class="poup-title">石头网 · 绑定手机号</h1>
    <div class="form-wrapper-new form1">
      <div class="form-box user-box form-item form1">
        <span class="form-item">
          <input
            type="text"
            name="user"
            id="user"
            placeholder="请输入手机号"
            data-validate="mobile"
            v-model.trim="mobileNumber"
            autocomplete="off"
          >
          <div class="error-msg-box"></div>
        </span>
      </div>
      <div class="form-box code-box form-item">
        <input
          type="text"
          name="code"
          id="code"
          placeholder="请输入手机验证码"
          data-validate="code"
          v-model.trim="smsCode"
          autocomplete="off"
        >
        <div class="error-msg-box"></div>
        <button class="code-msg-box" :disabled="disabled" @click="getSmsCode">{{smsText}}</button>
      </div>
      <div class="bind-notice-box">为了您的账户安全，请尽快绑定手机号</div>
      <button class="login-btn" @click="bindMobile" :disabled="forbidden">立即绑定</button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    clearform:{
			type:Boolean
		}
  },
  data() {
    return {
      accessToken: "",
      refreshToken: "",
      mobileNumber: null,
      smsCode: null,
      smsText: "获取验证码",
      seconds: 60,
      timer: null,
      disabled: false,
      forbidden: false,
      saveMoblie: ""
    };
  },
  components: {},
  watch:{
			clearform:function(v,n){
				if (v!=n) {
					this.mobileNumber=null;
          this.smsCode=null;
          this.smsText="获取验证码";
          this.seconds=60;
          this.disabled=false;
          this.forbidden=false;
          this.saveMoblie='';
          clearInterval(this.timer);
          if (	$('div.error-msg-box').hasClass('error-msg-show')) {
            $('div.error-msg-box').removeClass('error-msg-show');
          }
				}
			}
	},
  created: function() {},
  mounted: function() {
    this.accessToken = this.cookies().read("access_token");
    this.refreshToken = this.cookies().read("refresh_token");
  },
  methods: {
    getSmsCode: function() {
      var _this = this;
      var data = {
        accessToken: _this.accessToken,
        mobileNumber: _this.mobileNumber
      };
      var opts = {
        isLoading: true,
        loadingDom: "",
        success: function(result) {
          _this.$message({
            showClose: true,
            message: "验证码发送成功！",
            type: "warning"
          });
          _this.saveMoblie = _this.mobileNumber;
        },
        failSendSms: function() {
          _this.smsCode = null;
          _this.seconds = 60;
          _this.smsText = "获取验证码";
          clearInterval(_this.timer);
          _this.disabled = false;
        },
        error: function(result) {
          _this.mobileNumber = null;
          _this.smsCode = null;
          // _this.$message({
          // 	showClose: true,
          // 	message: result.message,
          // 	type: 'warning'
          // });
          _this.$layer.msg(result.message);
          if (_this.timer) {
            clearInterval(_this.timer);
            _this.disabled = false;
            _this.seconds = 60;
            _this.smsText = "获取验证码";
          }
        }
      };
      var isValidate = doValidate("div.user-box");
      if (isValidate) {
        _this.disabled = true;
        _this.smsText = _this.seconds + "秒后重新获取";
        _this.$options.methods.setIntervalSecs(_this);
        _this.getAjaxCommon(
          accountBaseUrl + "/account/bindMobileSendCode",
          "post",
          data,
          opts
        );
      }
    },
    setIntervalSecs: function($this) {
      var _this = $this;
      _this.timer = setInterval(function() {
        _this.seconds--;
        _this.smsText = _this.seconds + "秒后重新获取";
        if (_this.seconds < 0) {
          clearInterval(_this.timer);
          _this.disabled = false;
          _this.seconds = 60;
          _this.smsText = "获取验证码";
        }
      }, 1000);
    },
    loginRequest: function($this) {
      var _this = $this ? $this : this;
      var data = {
        accessToken: _this.accessToken,
        mobileNumber: _this.mobileNumber,
        smsCode: _this.smsCode
      };
      var opts = {
        isLoading: true,
        loadingDom: "",
        success: function(result) {
          if (result.path.indexOf("bindMobile") != -1) {
            _this.cookies().write("mobile", _this.mobileNumber, 7);
            _this.cookies().write("mobileAuthLocked",'true', 7);
            //_this.forbidden=false;
            _this.$emit("poupwhich",'noticePoup'); //弹出notice弹窗
            // 通知top去获取用户信息
            _this.$emit("getuserinfo");
          } else {
            _this.cookies().write("access_token", result.content.access_token);
            _this.cookies().write("refresh_token", result.content.refresh_token);
            _this.access_token = result.content.access_token;
            _this.refresh_token = result.content.refresh_token;
            _this.getAjaxCommon(
              accountBaseUrl + "/account/bindMobile",
              "post",
              data,
              opts
            );
          }
        },
        getNewAccessToken: function() {
          _this.getAjaxCommon(
            accountBaseUrl + "/account/refreshToken",
            "post",
            { refreshToken: _this.refreshtoken },
            opts
          );
        },
        jumpToLogin: function() {
          // 弹出互踢弹窗
          _this.$emit("poupwhich", "loginOut"); //hide loginPoup
        },
        error: function(result) {
          _this.forbidden = false;
          _this.mobileNumber = null;
          _this.smsCode = null;
          // _this.$message({
          // 	showClose: true,
          // 	message: result.message,
          // 	type: 'warning'
          // });
          _this.$layer.msg(result.message);
          if (_this.timer) {
            clearInterval(_this.timer);
            _this.disabled = false;
            _this.seconds = 60;
            _this.smsText = "获取验证码";
          }
        }
      };
      _this.getAjaxCommon(
        accountBaseUrl + "/account/bindMobile",
        "post",
        data,
        opts
      );
    },
    bindMobile: function() {
      var isValidate = doValidate("div.form-wrapper-new");
      if (isValidate && this.accessToken) {
        if (this.saveMoblie == this.mobileNumber) {
          this.forbidden = true;
          this.$options.methods.loginRequest(this);
        } else {
          this.$message({
            showClose: true,
            message: "请重新获取新手机号验证码！",
            type: "warning"
          });
          clearInterval(this.timer);
          this.disabled = false;
          this.seconds = 60;
          this.smsText = "获取验证码";
          this.smsCode = null;
        }
      }
    }
  }
};
</script>
<style lang="scss"  scoped="scoped">
@import "~scss/mixin";
@import "~scss/poup";
* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -ms-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
div.bind-tel-box {
  width: 446px;
  height: 400px;
//   z-index: 100;
  h1.poup-title {
    background: url(~images/bind_tel_title.png) no-repeat 10px 10px;
    text-indent: -9999px;
    margin-bottom: 42px;
    height: 40px;
  }
  div.form-wrapper-new {
    div.code-box {
      > input {
        padding-right: 140px;
      }
    }
    div.bind-notice-box {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid #fef4e5;
      background-color: #fef7ed;
      margin-bottom: 46px;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/bindTelPoup.vue